import React from "react";
import UseCaseHeader from "components/UseCaseHeader";
import { DESKTOP } from "utils/constants/ui";
import { USE_CASES } from "utils/constants/useCases";

const UseCaseGrid = () => {
  const nodes = [
    USE_CASES.EMAIL,
    USE_CASES.SOCIAL,
    USE_CASES.VIDEO,
    USE_CASES.SMS,
    USE_CASES.CONTACTLESS
  ].map((type, typeIx) => (
    <li className="useCase--item pt3" key={typeIx}>
      <UseCaseHeader
        type={type}
        key={typeIx}
        customClasses={{
          container: "flex flex-column items-center pb2",
          copy: "f7 f5-l fw6 lh-title flex flex-shrink-0"
        }}
      />
    </li>
  ));
  nodes.push(
    <li
      className="useCase--item pt3 flex items-center justify-center"
      key="more"
    >
      <div className="f6 f5-l tc pl2">+ more</div>
    </li>
  );

  return (
    <section className="iconGrid flex flex-column justify-center w-100 pt3 pt4-l">
      <ul className="dib ma0 pa0 flex flex-wrap list">{nodes}</ul>
      <style jsx>{`
        :gloabl(.useCase--item) {
          width: 25%;
        }
        @media (min-width: ${DESKTOP}px) {
          :global(.useCase--item) {
            width: ${100 / nodes.length}%;
          }
        }
      `}</style>
    </section>
  );
};

export default UseCaseGrid;
